import { getPageKey } from '@/tracks/getPageKey';
import { extractUtmItmParams } from '@/utils/url';
import { isValidArray } from '@weee-fe/utilities';

/**
 * Banner会发出的埋点类型
 * 这里只拦截Banner的imp和click埋点
 */
const adsEventTypes = ['t2_banner_imp', 't2_click_action'];
export const adsBannerFilter = (events: any[]) => {
  if (isValidArray(events)) {
    events.forEach(event => {
      const { type, params } = event;
      if (adsEventTypes.includes(type)) {
        const co = params?.co || {};
        const target_type = co?.target_type;
        const url = co?.url;
        const utmItmParams = url ? extractUtmItmParams(url) : {};
        switch (type) {
          case 't2_banner_imp': {
            if (url && Object.keys(utmItmParams).length > 0) {
              event.params.co = {
                ...event.params.co,
                ...utmItmParams,
                url
              };
            }
            break;
          }
          case 't2_click_action': {
            if (target_type && target_type !== 'product') {
              if (url && Object.keys(utmItmParams).length > 0) {
                event.params.co = {
                  ...event.params.co,
                  ...utmItmParams,
                  url
                };
              }
            }
            break;
          }
          default:
            break;
        }
      }
    });
  }
  return events;
};

// page_target 转换为 page_ctx_app 的 key
const PAGE_TARGET_TO_CTX_APP_KEYS: string[] = [
  'mweb_product',
  'mweb_mkpl_seller',
  'mweb_collection',
  'mweb_sayweee_collection',
  'mweb_search_result',
  'mweb_brand',
  'mweb_order_detail',
  'mweb_share_list_detail',
  'mweb_help_view',
  'mweb_help_detail',
  'mweb_promotion_landing'
];

/**
 * 将page_target转换为page_ctx_app 的 key
 */
export const pageTargetToCtxAppKey = (events: ObjectType[]) => {
  if (!isValidArray(events)) return events;
  const pageUrl = location.href;
  const pageKey = getPageKey(pageUrl);
  if (!pageKey) return events;
  if (PAGE_TARGET_TO_CTX_APP_KEYS.includes(pageKey)) {
    events.forEach(event => {
      if (event.type === 'page_view') {
        event.page_ctx_app = event.page_ctx_app || {};
        const pageTarget = event.params?.ctx?.page_target;
        //需要同时将page_target写入埋点的 page_ctx_app 中
        window._weeeTracker?.setPageCtxApp?.(
          {
            page_target: pageTarget
          },
          true
        );

        if (pageTarget) {
          event.page_ctx_app.page_target = pageTarget;
          // 清理原字段
          if (event.params?.ctx?.page_target) {
            delete event.params.ctx.page_target;
          }
        }
      }
    });
  }
  return events;
};
